module.exports = __webpack_public_path__ + "static/img/int4.fa751725.jpg";